const API_URL = process.env.REACT_APP_API_URL;
const token = localStorage.getItem("token");
const GOOGLE_API_KEY = "AIzaSyCQrm7XQRxGSy8e0OFpSAT21_GFaB-Elcc";

function getRoleName() {
  const roleId = getUserRoleId();
  switch (roleId) {
    case "1":
      return "Administrateur";
    case "2":
      return "Distributeur";
    case "3":
      return "Revendeur";
   case "4":
      return "Technicien";
    case "5":
      return "Client";
  }
}

function getParentRoleName() {
  const roleId = getUserRoleId();
  switch (roleId) {
    case "1":
      return "Administrateur";
    case "2":
      return "Administrateur";
    case "3":
      return "Distributeur";
   case "4":
      return "Revendeur";
    case "5":
      return "Revendeur";
  }
}

function getApiConfig() {
  const token = localStorage.getItem("token");

  return {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
}

function getMultipartConfig() {
  const token = localStorage.getItem("token");

  return {
    headers: {
      Accept: "application/json",
      "Content-Type": "multipart/form-data",
      Authorization: "Bearer " + token,
    },
  };
}

function getUserRoleId() {
  return localStorage.getItem("user_role_id");
}

function getUserId() {
  return localStorage.getItem("user_params_id")
}

function getGoogleAPI() {
  return "AIzaSyCQrm7XQRxGSy8e0OFpSAT21_GFaB-Elcc"
}

export { API_URL, token, GOOGLE_API_KEY, getApiConfig, getMultipartConfig, getUserRoleId, getUserId, getGoogleAPI, getRoleName, getParentRoleName };